<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/148/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为进一步吸引人才发展产业，做大做强县域经济，促进蒲江县域经济高质量发展，根据《成都市蒲江县吸引人才发展产业做大做强县域经济政策措施实施细则》（蒲发改函〔2024〕1号）要求，对纳入白名单的在蒲创新创业就业高素质人才，实现乘坐成蒲铁路来返蒲单次通勤成本不高于10元。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/146/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            在蒲创新创业就业的高素质人才，符合《成都市人才分类目录》中A、B、C、D、E类人才标准。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/146/title2.png" alt="" />
          <div class="content" style="background-color: #fff">
            对高素质人才实现乘坐成蒲铁路来返蒲单次通勤10元。
          </div>
        </div>
        <div class="part-two">
          <img src="../assets/imgs/146/title3.png" class="part-two-title-img" />
          <div
            style="
              margin-top: 1.44rem;
              font-size: 0.3rem;
              font-weight: 500;
              color: #333333;
              line-height: 0.44rem;
              text-align: left;
            "
          >
            以下材料需一式两份，一份由接收申请单位留存，一份报备县委组织部（县委人才办）。
          </div>
          <div class="part-two-content" style="margin-top: 0.23rem">
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">1</div>
              成蒲铁路人才通勤10元票价优惠试点“高素质人才”类别申办审核表（扫二维码获取）；
            </div>
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">2</div>
              申请人身份证复印件；
            </div>
            <div style="margin-bottom: 0.22rem; position: relative">
              <div class="part-two-dot">3</div>
              符合相应人才分类的佐证材料复印件。
            </div>
          </div>
        </div>
        <div class="part-four">
          <img src="../assets/imgs/145/title4.png" class="part-two-title-img" />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                申请人向所在单位或行业主管部门提交申办材料。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">审核</div>
              </div>
              <div class="part-four-content1">
                接收申请单位对申请人提交的申办材料进行审核，若申办材料不齐全或经审核不符合相关要求，及时告知申请人。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">汇总</div>
              <div class="part-four-content1">
                审核通过后，接收申请单位将申请人员的申办材料及《成蒲铁路人才通勤10元票价优惠试点“高素质人才”类别申办汇总表》（纸质档）报送至县委组织部（县委人才办），同时做好申办材料存档工作，县委组织部（县委人才办）将进行抽查。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">审查</div>
              <div class="part-four-content1">
                县委组织部（县委人才办）对申请人进行违纪违法、涉警涉案、涉诉涉法及是否进入失信人名单等方面的资格审查，存在有关情形的，告知提交申请单位不予通过。如无相关情形，则将符合申办条件的人员名单抄送至县交运局进行办理。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg4">办理</div>
              <div class="part-four-content1">
                县交运局收到汇总名单后将人员信息录入“白名单”，协调办理成蒲铁路人才通勤10元票价优惠试点“高素质人才”类别优惠资格。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/148/title5.png" alt="" />
          <div
            class="content"
            style="background-color: #fff; font-weight: bolder"
          >
            全年工作日。
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/146/title6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88524685">028-88524685</a>
              </div>
            </div>
            <div
              class="unit"
              style="
                border-bottom: 0.01rem dashed #0839b7;
                padding-bottom: 0.2rem;
              "
            >
              <span class="label">责任单位：</span>
              蒲江县委人才办
            </div>
          </div>
          <div class="content" style="border-bottom: 1px solid #0839b7">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88555176">028-88555176</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              蒲江县交运局
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="info" src="../assets/imgs/148/code.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.part-two-title-img {
  width: 7.03rem;
  height: 1.37rem;
  top: 0;
  left: -0.2rem;
  position: absolute;
}

.part-two {
  margin-left: 0.02rem;
  width: 6.85rem;
  margin-top: 0.22rem;
  background: #e8eeff;
  border-radius: 0.16rem;
  padding-left: 0.25rem;
  padding-right: 0.3rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;

  .part-two-title {
    text-align: left;
    margin-left: 0.33rem;
    margin-bottom: 0.22rem;

    &::before {
      position: absolute;
      content: "";
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      background: none;
      border: 0.06rem solid #ff6d60;
      box-sizing: border-box;
      top: 0.08rem;
      left: -0.35rem;
    }
  }

  .part-two-items {
    width: 6.35rem;
    padding-bottom: 0.35rem;
    background: #ffffff;
    border-radius: 10px;
    padding: 0.31rem;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 0.22rem;
  }
  .part-two-content {
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    width: 6.22rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0.34rem 0.24rem 0.15rem 0.67rem;
    font-size: 0.26rem;
    // //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4e4e;
    line-height: 0.44rem;
    text-align: left;

    .part-two-dot {
      position: absolute;
      top: 0;
      left: -0.46rem;
      width: 0.36rem;
      height: 0.36rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 0.21rem;
      background: #739bfe;
      border-radius: 50%;
    }
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    height: 5.65rem;
  }

  .technological-process {
    transform: translateY(-2.2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
